import { SkeletonText } from '@neshane/blueberry';

/**
 * Loader shown while the admin terms page is first fetching versions.
 */
export const TermsPageLoader = () => {
    return (
        <div className="w-full max-w-2xl flex flex-col gap-16">
            <div className="mb-8">
                <SkeletonText size="xl" width="200px" className="mb-8" />
                <SkeletonText width="80%" />
            </div>
            {[0, 1, 2].map((i) => (
                <div key={i} className="flex flex-col gap-8 p-16 border rounded-12">
                    <SkeletonText width="120px" />
                    <SkeletonText width="70%" />
                    <SkeletonText width="40%" />
                </div>
            ))}
        </div>
    );
};

export default TermsPageLoader;